import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d9a2478"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "how-to",
  href: "#"
}, "how to add a task", -1))
const _hoisted_2 = {
  href: "#",
  class: "speech-bubble"
}

import { computed, ref, watch } from "vue"
import { useUserStore } from "@/store"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useUserStore()

const userName = ref("")

watch(
  () => store.user,
  () => {
    userName.value = store.user.handle
  }
)

const userFirstLetter = computed(() =>
  userName.value ? `${userName.value.charAt(0)}.` : ""
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("p", null, "Total tasks created — " + _toDisplayString(_unref(store).total_tasks_created), 1),
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("a", _hoisted_2, _toDisplayString(_unref(userFirstLetter)), 1)
    ])
  ]))
}
}

})